import type { Writable } from '@eturi/ts-helpers'
import type { AppRules, DeviceApp } from '../types/AppRules.js'

type BundleIdAndTitleTuple = [bundleId: string, title: string]

export const MockDeviceApps = (() => {
	const MOCK_BUNDLE_IDS_AND_TITLES: BundleIdAndTitleTuple[] = [
		['com.facebook.Facebook', 'Facebook'],
		['com.burbn.instagram', 'Instagram'],
		['com.zhiliaoapp.musically', 'TikTok'],
		['com.mojang.minecraftpe', 'Minecraft'],
		['com.google.ios.youtube', 'YouTube'],
		['com.505games.terraria', 'Terraria'],
		['net.whatsapp.WhatsApp', 'WhatsApp'],
		['com.spotify.client', 'Spotify'],
		['com.toyopagroup.picaboo', 'Snapchat'],
	]
	const MOCK_DEVICE_APP_TEMPLATE: DeviceApp = {
		bundleId: '',
		detailsBundleId: '',
		description: '',
		detailed_version: '',
		deviceDisplayNames: [''],
		display_version: '',
		granularity: 'S',
		is_system: false,
		os: 'iOS',
		supervision_required: true,
		title: '',
	}
	let mockAppRules: AppRules | null = null

	const createMockDeviceApp = (bundleId: string, title: string): DeviceApp => ({
		...MOCK_DEVICE_APP_TEMPLATE,
		bundleId,
		detailsBundleId: bundleId,
		title,
	})

	const getMockAppRules = (): AppRules =>
		(mockAppRules ||= MOCK_BUNDLE_IDS_AND_TITLES.reduce(
			(appRules: Writable<AppRules>, [bundleId, title]) =>
				Object.assign(appRules, { [bundleId]: createMockDeviceApp(bundleId, title) }),
			{},
		))

	const getMockAppBundleIds = (): ReadonlySet<string> =>
		new Set(MOCK_BUNDLE_IDS_AND_TITLES.map(([bundleId]) => bundleId))

	return { getMockAppRules, getMockAppBundleIds }
})()
